import _merge from 'lodash/merge';
import * as styles from './staticFiles.styles';
import { HEADER_1, HEADER_2, HEADER_3, PARAGRAPH, LIST, ORDERED_LIST } from './staticFiles.constants';

const renderH1Node = (node, config) => {
  const { content } = node;
  const { wordWrap } = config;

  return _merge(
    {
      text: {
        text: content,
        wordWrapWidth: wordWrap,
      },
    },
    styles.header1NodeStyle(config),
  );
};

const renderH2Node = (node, config) => {
  const { content } = node;
  const { wordWrap } = config;

  return _merge(
    {
      text: {
        text: content,
        wordWrapWidth: wordWrap,
      },
    },
    styles.header2NodeStyle(config),
  );
};

const renderH3Node = (node, config) => {
  const { content } = node;
  const { wordWrap } = config;

  return _merge(
    {
      text: {
        text: content,
        wordWrapWidth: wordWrap,
      },
    },
    styles.header3NodeStyle(config),
  );
};

const renderPNode = (node, config) => {
  const { content } = node;
  const { wordWrap } = config;

  return _merge(
    {
      text: {
        text: content,
        wordWrapWidth: wordWrap,
      },
    },
    styles.paragraphNodeStyle(config),
  );
};

const renderListItem = (node, config) => {
  const { content } = node;
  const { wordWrap } = config;
  const text =
    typeof content === 'object' && content.originalIndex
      ? `  ${content.originalIndex}.  ${content.content}`
      : `  •  ${content.content}`;

  return _merge(
    {
      text: {
        text,
        wordWrapWidth: wordWrap,
      },
    },
    styles.paragraphNodeStyle(config),
  );
};

const renderListNode = (node, config) => {
  const { content } = node;

  return _merge(
    {
      children: content.map(item => renderListItem({ content: item }, config)),
    },
    styles.listNodeStyle(config),
  );
};

const renderOrderedListItem = (node, config) => {
  const { content, index } = node;
  const { wordWrap } = config;

  const text =
    typeof content === 'object' && content.originalIndex
      ? `  ${content.originalIndex}.  ${content.content}`
      : `  ${index + 1}.  ${content}`;

  return _merge(
    {
      text: {
        text,
        wordWrapWidth: wordWrap,
      },
    },
    styles.paragraphNodeStyle(config),
  );
};

const renderOrderedListNode = (node, config) => {
  const { content } = node;

  return _merge(
    {
      children: content.map((item, index) => renderOrderedListItem({ content: item, index }, config)),
    },
    styles.listNodeStyle(config),
  );
};

export const renderNode = (node, config) => {
  switch (node.tag) {
    case HEADER_1:
      return renderH1Node(node, config);
    case HEADER_2:
      return renderH2Node(node, config);
    case HEADER_3:
      return renderH3Node(node, config);
    case PARAGRAPH:
      return renderPNode(node, config);
    case LIST:
      return renderListNode(node, config);
    case ORDERED_LIST:
      return renderOrderedListNode(node, config);
    default:
      return {};
  }
};

export const renderFile = (file, config) => {
  const lastItemIndex = file.length - 1;

  return file.map((node, i) => {
    const isLastItem = i === lastItemIndex;
    const newNode = renderNode(node, config);

    if (newNode.children && newNode.children.length > 0) {
      newNode.children[newNode.children.length - 1].flexItem.marginBottom = 0;
    }

    if (isLastItem) {
      newNode.flexItem.marginBottom = 0;
    }

    return newNode;
  });
};
